module.exports = __webpack_public_path__ + "media/images/beer-578fdf333a62e4d1ee9eb41f971f736f.jpg";